import loglevel from 'loglevel'

if (process.env.FRONT_ENV === 'production') {
  loglevel.setLevel('warn')
} else {
  loglevel.setLevel('debug')
}

export const log = loglevel
